import {buildGateway} from './buildGateways';
import {
  getPageBindingContextNode as internalGetPageBindingContextNode,
  forTestSuite_consolidateBindingContext,
  type BindingContextGraphNode,
} from './binding-context';
import type {PageRecordType} from '@packages/systems/core/records/PageRecord';
import type {CollectionsType} from '@packages/systems/core/records/CollectionStateType';
import type {GatewayRuntimeEnvironment} from './types';

export type {
  BindingContextGraphNode,
  ConsolidatedBindingContext,
} from './binding-context';
export type {BindingSource, BindingContextTypeReference} from './primitives';

export {
  bindingContextBoundaryElementTypes,
  getElementConnectionOptions,
  getElementBindingContext,
  getPageBindingContext,
  isBindingContextBoundaryElement,
  validateDynamicContext,
} from './binding-context';
export {areReferencesToSameEntity} from './primitives';

type PublicGetPageBindingContextNode = (
  page: PageRecordType,
  collections: CollectionsType,
  runtimeEnvironment: GatewayRuntimeEnvironment
) => BindingContextGraphNode;

export type {GatewayRuntimeEnvironment};

// re-type the function on export to limit public BindingContextGraphNode API
// to just the methods used by Dynamo Query Builder
export const getPageBindingContextNode: PublicGetPageBindingContextNode =
  internalGetPageBindingContextNode;

export const forTestSuite = {
  consolidateBindingContext: forTestSuite_consolidateBindingContext,
  buildGatewayForTest: buildGateway,
} as const;
